import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
}

const BasicFilter = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24">
      <path d="M20.951,0c1.656,0 2.998,1.336 2.998,2.983c0,0.77 -0.299,1.508 -0.832,2.062l-0.046,0.047l-7.626,7.587l0,6.02c0,0.783 -0.3,1.175 -0.899,1.175c-0.6,0 -0.9,-0.392 -0.9,-1.175l0,-4.308l-0.005,0.004l0,-2.451l8.158,-8.117c0.214,-0.213 0.339,-0.499 0.35,-0.799l0.001,-0.045c0,-0.647 -0.517,-1.173 -1.162,-1.193l-17.991,0c-0.318,0 -0.623,0.126 -0.848,0.35c-0.458,0.455 -0.468,1.189 -0.029,1.657l0.03,0.03l8.193,8.152l0,0.051l0.006,0l-0.006,10.779c0.004,0.794 -0.291,1.191 -0.885,1.191c-0.594,0 -0.899,-0.397 -0.914,-1.191l0.005,-10.083l-7.672,-7.634c-1.17,-1.165 -1.17,-3.053 0,-4.218c0.548,-0.544 1.283,-0.856 2.054,-0.874l18.02,0Z" />
    </svg>
  );
};

export default BasicFilter;
